import { CloudPlusIcon, PeopleIcon, Plus } from "../../images/icons/icons";

// Subscription Tabs Component (similar to PayrollMainTabs)
const SubscriptionMainTabs = ({ activeTab, setActiveTab }) => {
    const subscriptionTabs = [
      {
        label: "Agent Request",
        value: "agent-request",
        icon: <PeopleIcon/>
      },
      {
        label: "Manual Extension",
        value: "manual-extension",
        icon: <Plus color="#000"/>
      },
    ];
  
    return (
      <div
        className="subscription-extension-main-tabs-container mt30"
        style={{ marginBottom: 20 }}
      >
        {subscriptionTabs.map((tab, idx) => (
          <div
            key={idx}
            className={`subscription-extension-main-tab${
              activeTab === tab.value ? " subscription-extension-main-tab-active" : ""
            }`}
            onClick={() => setActiveTab(tab.value)}
            style={{ cursor: "pointer" }}
          >
            {tab.icon}
            <span style={{ marginLeft: 8 }}>{tab.label}</span>
          </div>
        ))}
      </div>
    );
  };
  

  export default SubscriptionMainTabs;